import { useSubflowTemplates } from '@hooks/subflow-templates/useSubflowTemplates';
import type React from 'react';
import { useTranslation } from 'react-i18next';

export const InfoSubflowTemplate: React.FC = () => {
  const { selectedTemplate } = useSubflowTemplates();
  const { t } = useTranslation();

  return (
    <div className='tailwind-modal-body'>
      <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
        <div className='col-span-1 flex gap-2 text-sm items-center'>
          <span className='font-medium'>
            {t('subflow-templates.info.name')}
          </span>
          <span className='italic flex items-center gap-0.5'>
            {selectedTemplate?.name}
          </span>
        </div>
        <div className='col-span-1 flex gap-2 text-sm items-center'>
          <span className='font-medium'>
            {t('subflow-templates.info.created-by')}
          </span>
          <span className='italic flex items-center gap-0.5'>
            {selectedTemplate?.createdBy?.name}
          </span>
        </div>
        <div className='col-span-1 flex gap-2 text-sm items-center'>
          <span className='font-medium'>
            {t('subflow-templates.info.created-from')}
          </span>
          <span className='italic flex items-center gap-0.5'>
            {selectedTemplate?.createdFrom?.name}
          </span>
        </div>

        <div className='tailwind-divider-x' />

        <div className='col-span-1 flex gap-2 text-sm'>
          <span className='font-medium'>
            {t('subflow-templates.info.created-at')}
          </span>
          <span className='italic'>
            {selectedTemplate?.createdAt
              ? new Date(selectedTemplate.createdAt).toLocaleString()
              : ''}
          </span>
        </div>
      </div>
    </div>
  );
};

export default InfoSubflowTemplate;
